module.exports = __webpack_public_path__ + "img/appAsset--documents-ax.df924213.svg";